import React from 'react';
import { Bar } from "react-chartjs-2";
import {sliceLastMonths, getBarChartDatasetStyleProperties, getYTicksProperties, getXOptions, getChartTitleOptions} from '../Utils/GraphsUtils';

export default class ObstacleHeightGraph extends React.Component {

    

    constructor(props) {
        super(props);
        this.state = { horsePerformanceDataGetter: props.horsePerformanceDataGetter };
    }

    getData(horsePerformanceData) {
        console.log('orig months:' + horsePerformanceData['month'])
        const dataMap = sliceLastMonths(horsePerformanceData['month'], horsePerformanceData['max_obstacle_height'], 12)
        console.log('sliced months:' + dataMap['months'])
        console.log('sliced obst. heights:' + dataMap['values'])
        var data = {
            labels: dataMap['months'],
            datasets: [
                {
                    label: "Obstacle height",
                    data: dataMap['values'],
                    ...getBarChartDatasetStyleProperties()
                }
            ]
        };

        return data;
    }

    getOptions() {
        return {
            aspectRatio: 2,
            scales: {
                y: {
                    min: 100,
                    max: 180,
                    grid: {
                        display: false,
                    },
                    ticks: {
                        callback: function (value) {
                            return value + ' cm';
                        },
                        stepSize: 20,
                        ...getYTicksProperties(),
                    }
                },
                x: getXOptions()
            },
            plugins: {
                title: {
                    text: 'Obstacle Height',
                    ...getChartTitleOptions()
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        label: function (context) {
                            return context.dataset.label + ': ' + context.parsed.y + ' cm';
                        }
                    },
                    usePointStyle: true
                }
            }
        }
    }

    render() {
        const horsePerformanceData = this.state.horsePerformanceDataGetter();
        let data = this.getData(horsePerformanceData);
        let options = this.getOptions(horsePerformanceData);
        return (
            <div className="w-full grid justify-items-center">
                <div className="w-full">
                    <Bar data={data} options={options} />
                </div>
            </div>
        );
    }

}